import styled from "styled-components"

export const Oval = styled.div`
	background: #d14444;
	border-radius: 50%;
	height: 20px;
	width: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
`

export const AlertWrapper = styled.div`
	padding: 5px 24px;
	display: flex;
`

export const MessageWrapper = styled.div`
	font-size: 15px;
`
